import {Fragment, useState, useEffect} from 'react';

import {Dialog} from 'primereact/dialog';
import {Button} from 'primereact/button';
import {useDataTable} from '../../../../shared/hooks/DataTable';
import {FormatDisplay} from '../../../../shared/format';

import {ToastService} from '../../../../AppToast';
import {ConfirmDialogService} from '../../../../AppConfirmDialog';

import {PetrolimexService} from '../PetrolimexService';

export const DialogViewHistory = (props) => {


  const {display, setDisplay, selectedItem} = props;

  const [requiredParams, setRequiredParams] = useState(null);

  const [version, setVersion] = useState(null);
  const [canRollback, setCanRollback] = useState(false);

  useEffect(() => {
    if (display && selectedItem?.id) {
      setRequiredParams({
        id: selectedItem.id
      });
    }
  }, [display, selectedItem]);

  const columns: any = []; 
  columns.push(     
    {field: 'timeChange', header: 'Thời gian',  matchMode: 'contains', dataType: 'date-time', filterType: 'date', width: 150},
    {field: 'result', header: 'Kết quả update giá', width: 160, matchMode: 'contains'},
    {field: 'deviceCode', header: 'Mã vòi', width: 160, matchMode: 'contains'},
    {field: 'userCreate', header: 'Người sửa', width: 160, matchMode: 'contains'},
    {field: 'priceOld', header: 'Giá cũ', width: 120, matchMode: 'contains', dataType: 'custom', customCell(rowData: any): any {
      return FormatDisplay.number(rowData.priceOld, {maximumSignificantDigits: `${rowData.priceOld}`.length})
      }, style: {justifyContent: 'end'}
    },
    {field: 'price', header: 'Đơn giá mới', width: 120, matchMode: 'contains', dataType: 'custom', customCell(rowData: any): any {
      return FormatDisplay.number(rowData.price, {maximumSignificantDigits: `${rowData.price}`.length})
      }, style: {justifyContent: 'end'}
    },
    {field: 'errorUpdateIOT', header: 'Trạng thái sửa giá trên hệ thống IOT', minWidth: 160},
  );

  const {render: renderDataTable} = useDataTable({
    columns,
    indexColumnWidth: 40,
    getList: (params) => {
      return PetrolimexService.getListHistory(params).then(data => {
        if (setCanRollback) {
          setCanRollback(data && data.totalCount === 0);
        }
        return data;
      });
    },
    requiredParams,
    selectionMode: 'single'
  });
  return (
    <Dialog header="Lịch sử điều chỉnh giá " visible={display} style={{width: '80vw'}} position="top" onHide={() => setDisplay(false)}>
				<Fragment>
				 {renderDataTable()}
				</Fragment>

      <div className="flex justify-content-end mt-2">
        <Button label="Đóng" icon="pi pi-times" onClick={() => setDisplay(false)} className="p-button-outlined p-button-secondary p-button-sm"/>
      </div>
    </Dialog>
  );
}